// store/uspsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const uspsSlice = createSlice({
    name: 'usps',
    initialState: {
        accessToken: null,
    },
    reducers: {
        setAccessToken: (state, action) => {
            state.accessToken = action.payload;
        },
    },
});

export const { setAccessToken } = uspsSlice.actions;
export default uspsSlice.reducer;
